import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { FaUsers } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import PeopleTab from "../../components/organization/Tabs/PeopleTab";
import TeamsTab from "../../components/organization/Tabs/TeamsTab";
import DelegationsTab from "../../components/organization/Tabs/DelegationsTab";
import ShiftTemplatesTab from "../../components/organization/Tabs/ShiftTemplatesTab";
import ScheduleTypesTab from "../../components/organization/Tabs/ScheduleTypesTab";
import { ROLES } from "../../utils/constants/roles";

const OrganizationPage = () => {
    const [activeTab, setActiveTab] = useState("people");
    const { t } = useTranslation();
    const { user } = useSelector((state) => state.auth);
    const isAdmin = [ROLES.SUPER_ADMIN, ROLES.MANAGER].includes(user?.role?.name);
    const TABS = [
        { id: "people", label: t("components.OrganizationPage.tabs.people", "Pessoas"), component: <PeopleTab isAdmin={isAdmin} /> },
        { id: "teams", label: t("components.OrganizationPage.tabs.teams", "Equipas"), component: <TeamsTab isAdmin={isAdmin} /> },
        { id: "delegations", label: t("components.OrganizationPage.tabs.delegations", "Delegações"), component: <DelegationsTab isAdmin={isAdmin} /> },
        ...(isAdmin ? [
            { id: "shifts", label: t("components.OrganizationPage.tabs.shifts"), component: <ShiftTemplatesTab /> },
            { id: "schedule_types", label: t("components.OrganizationPage.tabs.scheduleTypes"), component: <ScheduleTypesTab /> },
        ] : [])
    ];

    if (!isAdmin && ["shifts", "schedule_types"].includes(activeTab)) {
        setActiveTab("people");
    }

    return (
        <Container fluid className="px-4 py-4" style={{ backgroundColor: "var(--white)", minHeight: "100vh" }}>
            
            {/* Header Section */}
            <div className="d-flex align-items-center gap-3 mb-4">
                <div 
                    className="d-flex align-items-center justify-content-center txt-inverse rounded" 
                    style={{ width: "40px", height: "40px", backgroundColor: "var(--brand-primary)" }}
                >
                    <FaUsers size={20} />
                </div>
                <h2 className="m-0 txt-main">
                    {t("components.OrganizationPage.title", "Organização")}
                </h2>
            </div>

            {/* Tabs Section */}
            <div className="mb-4 d-flex gap-4" style={{ borderBottom: "var(--border-thin)" }}>
                {TABS.map((tab) => (
                    <button
                        key={tab.id}
                        className={`btn rounded-0 px-1 py-2 transition-all ${
                            activeTab === tab.id ? "txt-main fw-bold" : "txt-subtle fw-semibold"
                        }`}
                        onClick={() => setActiveTab(tab.id)}
                        style={{
                            boxShadow: "none",
                            border: "none",
                            backgroundColor: "transparent",
                            borderBottom: activeTab === tab.id 
                                ? "2px solid var(--text-primary)" 
                                : "2px solid transparent",
                        }}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Content Section */}
            <div className="organization-content">
                {TABS.find((tab) => tab.id === activeTab)?.component}
            </div>

        </Container>
    );
};

export default OrganizationPage;
